import React from 'react';
import { useBacterialFunctionalDiversityMetricsQuery } from 'src/app/dashboard/state/metrics/metricsGraphSlice';
import Loader from 'src/shared/components/loader/Loader';
import useProject from 'src/shared/hooks/useProject';
import functionalDiversityImageUrl from 'src/assets/images/dashboard/functional_diversity.svg?url';
import useProjectFilters from 'src/shared/hooks/useProjectFilters';
import TimeseriesCardTemplate from '../components/TimeseriesCardTemplate';

import styles from '../Metrics.module.scss';

const BacterialFunctionalDiversityMetrics = () => {
    const chartTitle = 'Bacterial Functional Diversity';
    const {
        currentProjectSelectedDateRange,
        currentProjectId,
        currentProjectSelectedHabitatAssayType: habitatAssayType,
    } = useProjectFilters();
    const { isSingleTimepoint } = useProject();
    const { currentData, isFetching } = useBacterialFunctionalDiversityMetricsQuery(
        {
            projectId: currentProjectId || '',
            fromDate: currentProjectSelectedDateRange?.startDate,
            toDate: currentProjectSelectedDateRange?.endDate,
            habitatAssay: habitatAssayType?.key || '',
        },
        {
            skip: !currentProjectId || !habitatAssayType,
        }
    );

    if (isFetching) {
        return <Loader />;
    }

    if (!currentData) {
        return null;
    }

    const content = (
        <TimeseriesCardTemplate
            title={chartTitle}
            titleHelpSlug='bacterial-functional-diversity'
            averageValueDescription='Diversity measured in [endYearWithQuarter]'
            metricsChartData={currentData.bacterialFunctionalDiversity}
            metricCardImageUrl={functionalDiversityImageUrl}
            metricCardContent='average functions per sample'
        />
    );

    if (isSingleTimepoint) {
        return content;
    }

    return <div className={styles.timeseriesCard}>{content}</div>;
};

export default BacterialFunctionalDiversityMetrics;
